import * as React from 'react';
// import Progress from './Progress';
import './Footer.scss';

const Footer = () => <footer>{/* <Progress /> */}</footer>;

export default Footer;
